import React, { useState, useRef, useEffect } from 'react';
import AvatarEditor from 'react-avatar-editor';

import { Button, Alert,Input, Col, Row, Modal, Slider } from 'antd';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import { CameraOutlined } from '@ant-design/icons';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';

export default function App({username,profile,setEquilizer,equilizer,userData}) {
  const [image, setImage] = useState(null);
  const [scale, setScale] = useState(1);
  const [display, setDisplay] = useState(null);
  const [openModal, setOpenModal] = useState(false);
 ////.log(username,profile,userData);
 let [profChanged,setPicAsSoonAsPPChanged]=useState(false)
 let dfaultProfile=username?.charAt(0)
  const editorRef = useRef();
   ////.log(profile);
  const changeHandler = (e) => {
    if (!e.target.files[0]) return;
    setImage(e.target.files[0]);
    setOpenModal(true);
    setPicAsSoonAsPPChanged(true)
  };
  let [isLoading,setLoading]=useState(false)
 let [error,getError]=useState("")
 
  const handleSubmit = async() => {   
    const url = editorRef.current.getImageScaledToCanvas().toDataURL();
    setDisplay(url);
    setLoading(true)
    //make axios requst here
    let value={
      profilePicture:url
    }
    //let stringfyValue=JSON.stringify(value)
    console.log(`${process.env.REACT_APP_URL}/api/user/update`);
    axios.put(`${process.env.REACT_APP_URL}/api/user/update`,value, //proxy uri
      {
          headers: {
            authorization:`Bearer ${userData?.token}` ,
            'Content-Type': 'application/json'
          } 
      })
      .then(function (response) {
        setLoading(false)
      //  console.log(response.data)
        setEquilizer(equilizer+2)
        setDisplaySuccessText(true)
        setTimeout(()=>{
          setDisplaySuccessText(false)
          //setLoading(false)
        },10000)
      }).catch((error) => {
        setLoading(false)
        getError("Error occured, check your internate connection or use valid image and try again")
      //   console.log(error);
        setTimeout(()=>{
          getError(false)
        },10000)
    });
    setOpenModal(false);
  };
  
  let [displaySuccessText,setDisplaySuccessText]=useState(false)

  return (
    <div className='all-contents-profile'>
      <Row justify="center">
        <Col>
           <div>
              <label>

              <Input
              type="file"
              id="fileInput"
              accept="image/*"
              onChange={changeHandler}
              hidden
              className='file-input'
              />
              {(profile||display)&& <CameraOutlined className='profileCameraIcon2' style={{cursor:"pointer"}} />
                }  
              </label>
           </div>
          </Col>
      </Row>
      <Row justify="center">
        <Col>
        {(profile||display)?
            <div className='all-contents-profile-image'><img style={{borderRadius:"100px"}} src={profChanged?display:profile} onClick={() =>{profChanged&&setOpenModal(true)}} /></div>
                       :
            <div className='ProfilePictue'>
                    <CameraOutlined className='profileCameraIcon1' />
            <div className='account-defaultProfilePicture'> {dfaultProfile?.toUpperCase()}</div>
        </div>}  
        </Col>
      </Row>
      
      <Modal
        title="Edit Profile Picture"
        visible={openModal}
        onOk={handleSubmit}
        onCancel={() => setOpenModal(false)}
      >
        <Row justify="center">
          <Col>
            <AvatarEditor
              ref={editorRef}
              image={image}
              width={200}
              height={200}
              borderRadius={100}
              border={30}
              scale={scale}
              rotate={0}
              color={[255, 255, 255, 0.6]}
            />
          </Col>
        </Row>

        <Row justify="center" align="middle">
          <Col>
            <PlusOutlined />
            <input
              type="range"
              min="1"
              max="5"
              step="0.1"
              value={scale}
              onChange={(e) => setScale(e.target.value)}
            />
            <MinusOutlined />
          </Col>
        </Row>
      </Modal>

     {profChanged&& (isLoading?<CircularProgress className='profile-picture-circulaarProgress'/>:
      <div className='successfulText'>
        {displaySuccessText&&
         <Alert message="Profile successfuly updated" type="success" showIcon />}
       </div>)} 
       <div>{error&&<Alert message={error}type="error" showIcon />} </div>
    </div>
  );
}